import React, { Component } from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import bootstrapPlugin from "@fullcalendar/bootstrap";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import FixtureDetailsModal from "./Modals/FixtureDetailsModal";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import calendarService from "../services/CalendarService";
import authorizeService from "./api-authorization/AuthorizeService";
import teamsService from "../services/TeamsService";
import competitionService from "../services/CompetitionService";

export class Calendar extends Component {
  static displayName = Calendar.name;

  constructor(props) {
    super(props);

    this.state = {
      fixtures: [],
      teamNames: [],
      competitions: [],
      userRole: null,

      loading: true,
      show: false,
      search: null,

      selectedFixture: null,
    };

    this.typaheadRef = React.createRef();
  }

  componentDidMount() {
    this.loadInitialData();
  }

  async loadInitialData() {
    await Promise.all([
      this.populateEvents(),
      this.loadUserRole(),
      this.loadCompetitions(),
      this.loadTeamNames(),
    ]);
  }

  async loadUserRole() {
    const userRole = await authorizeService.getUserRole();
    this.setState({ userRole });
  }

  async loadCompetitions() {
    const competitions = await competitionService.getCompetitions();
    this.setState({ competitions });
  }

  async loadTeamNames() {
    const teams = await teamsService.getTeamsList();
    this.setState({ teamNames: teams.map((t) => t.name) });
  }

  async populateEvents() {
    const fixtures = await calendarService.getCalendarEvents();
    this.setState({ fixtures, loading: false });
  }

  toggleShowModal = (show) => {
    this.setState({ show });
  };

  hideModal = async (success) => {
    if (success) {
      await this.populateEvents();
    }
  };

  handleEventClick = async (clickInfo) => {
    const props = clickInfo.event.extendedProps;
    if (!props) return;
    this.setState({
      selectedFixture: {
        event: clickInfo.event.extendedProps,
      },
      show: true,
    });
  };

  getFilteredFixtures() {
    const { fixtures, search } = this.state;

    if (!search || search.length === 0) return fixtures;

    const results = [];

    search.forEach((term) => {
      fixtures.forEach((fixture) => {
        const isMatch =
          fixture.title.includes(term) || fixture.competition === term;

        const alreadyAdded =
          fixture.fixtureRoomId &&
          results.some((r) => r.fixtureRoomId === fixture.fixtureRoomId);

        if (isMatch && !alreadyAdded) {
          results.push(fixture);
        }
      });
    });

    return results;
  }

  renderModal() {
    const { selectedFixture, show, userRole } = this.state;
    if (!selectedFixture?.event) return null;

    return (
      <FixtureDetailsModal
        show={show}
        onHide={() => this.toggleShowModal(false)}
        userRole={userRole}
        fixture={selectedFixture.event}
        onStartRoom={(newFixtureDetail) => {
          this.populateEvents();
           this.setState((prevState) => ({
            selectedFixture: {
              ...prevState.selectedFixture,
              event: {
                ...prevState.selectedFixture.event,
                fixtureRoomId: newFixtureDetail.fixtureRoomId,
                id: newFixtureDetail.id,
              },
            },
          }));
        }}
      />
    );
  }

  renderDropdown() {
    const { competitions, teamNames } = this.state;

    const competitionNames = competitions.map((c) => c.name);
    const options = [...competitionNames, ...teamNames].map((name) => ({
      id: name,
      label: name,
      type: teamNames.includes(name) ? "team" : "competition",
    }));

    return (
      <Typeahead
        id="calendar-typeahead"
        ref={this.typaheadRef}
        clearButton
        multiple
        options={options}
        placeholder="Type to search teams or competitions..."
        onChange={(selected) =>
          this.setState({
            search: selected?.map((s) => s.id) || null,
          })
        }
      />
    );
  }

  renderCalendar(events) {
    return (
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, bootstrapPlugin]}
        themeSystem="bootstrap"
        initialView="dayGridMonth"
        headerToolbar={{
          left: "title",
          center: "",
          right: "prev,next today dayGridMonth,timeGridWeek,timeGridDay",
        }}
        eventTimeFormat={{
          hour: "2-digit",
          minute: "2-digit",
          meridiem: true,
        }}
        events={events}
        eventContent={renderEventContent}
        eventClick={this.handleEventClick}
      />
    );
  }

  render() {
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="mt-3">
          <p>
            <em>Loading...</em>
          </p>
        </div>
      );
    }

    const fixtures = this.getFilteredFixtures();

    return (
      <div className="mt-3">
        <Row className="mb-2 mr-0">
          <Col sm="6" lg="4">
            {this.renderDropdown()}
          </Col>
        </Row>

        {this.renderCalendar(fixtures)}
        {this.renderModal()}
      </div>
    );
  }
}

function renderEventContent(eventInfo) {
  return (
    <span>
      {eventInfo.timeText} {eventInfo.event.title}
    </span>
  );
}
